module.exports = __webpack_public_path__ + "static/media/slider-01.99008d3a.png";